import { styled } from '~/styled'

/**
 * A flexible flex spacer that expands along the major axis of its containing flex layout.
 * It renders a `div` by default, and takes up any available space.
 */
export const Spacer = styled('div', {
  base: ['flex-1', 'justify-self-stretch', 'self-stretch']
})

Spacer.displayName = 'Spacer'
